
import { onChangeTabsManager, symbolsListManager, useInstrumentsStatic, useSymbolsListGroup } from "@/controllers/gridManager/PriceboardManager";
import SymbolSelectorTableNew from "@/views/components/Priceboard/SymbolSelectorNew/SymbolSelectorTableNew";
import { memo, useEffect, } from "react";
import { useStateIfMounted } from 'use-state-if-mounted';
// import './PriceboardComponents.scss';
import { subSocketMarketManager } from "@/controllers/gridManager/socketManager/SocketManager";
import { reduxVariableStatus } from "@/stores/dataStore/memoryStore/const/constIndex";
import Random from "@/utilities/random";
import ListMarketIndexes from "../MarketIndex/ListMarketIndexes";
import './PriceboardComponents.css';
// import SymbolSelectorMenu from "./SymbolSelectorMenu/SymbolSelectorMenu";
// const SymbolSelectorTableNew = lazy(() => import(/* webpackChunkName: "PBT" */ "@/views/components/Priceboard/SymbolSelectorNew/SymbolSelectorTableNew"));
// import SymbolSelectorTableNew from "./Priceboard/SymbolSelectorNew/SymbolSelectorTableNew";
interface PropsComponents {
    // gridTheme?: string;
    // isDarkMode?: boolean;
    // instruments: object;
    // listByExchange: string[];
    // symbolsIsReady: boolean;
    isShowIndexChart: boolean;
    isShowPriBoard: boolean;
}
// interface IndexChartProps {
//     // const isShowIndexChart = true
// }
const PriceboardComponents = memo<PropsComponents>(({ isShowIndexChart, isShowPriBoard }) => {
    // const { symbolsList } = useSymbolsList() as any
    const { symbolsListStatus } = useSymbolsListGroup() as any
    // const { instrumentsStatic, instrumentsStaticStatus } = useInstrumentsStatic() as any
    const { instrumentsStaticStatus } = useInstrumentsStatic() as any

    // console.log("symbolsList.:", symbolsList)
    const [idPbTab, setIdPbTab] = useStateIfMounted<string>("HOSE");
    const [listSymbols, setListSymbols] = useStateIfMounted<any>([]);
    const [dataSymbols, setDataSymbols] = useStateIfMounted<any>([]);
    const [callerId] = useStateIfMounted<any>(Random.randomComponentId());
    const { getSymbolsListManager: _getSymbolsListManager } = symbolsListManager()
    const getSymbolsList = () => {
        // lấy dữ liệu danh sách mã CK.: Phục vụ tìm kiếm mã CK trên bảng giá
        _getSymbolsListManager()
    }
    useEffect(() => {
        // console.log('PriceboardComponents useEffect: get api', new Date().getTime())
        getSymbolsList()
        let params = {
            idPbTab: "HOSE", // Mặc định chọn tab HOSE cho lần đầu tiên
            isForce: true,
        }
        let paramsSocket = {
            callerId,
            idPbTab,
            symbols: []
        }
        subSocketMarketManager(paramsSocket)
        onChangeTabs(undefined, params)
    }, [])

    useEffect(() => {
        if (symbolsListStatus == reduxVariableStatus.LOADED && instrumentsStaticStatus == reduxVariableStatus.LOADED) {
            const { getSymbolsByIdPbTabManager } = onChangeTabsManager()
            let listSymbols = getSymbolsByIdPbTabManager({ idPbTab: idPbTab })
            let symbols = listSymbols?.list
            setListSymbols(symbols)
            setDataSymbols(listSymbols?.data)
            let params = {
                callerId,
                idPbTab,
                symbols
            }
            subSocketMarketManager(params)
        }
        // alert(isShowIndexChart) 
    }, [idPbTab, symbolsListStatus, instrumentsStaticStatus])



    const { getSymbolsListManager } = onChangeTabsManager()
    const onChangeTabs = (e: any, params: { idPbTab: string }) => {
        let { idPbTab } = params
        // xử lý UI/UX giao diện: Active tab
        setIdPbTab(idPbTab)
        console.log("onChangeTabs", e, idPbTab)
        // call onClickChangeTabsManager: get data
        getSymbolsListManager(params)
    }

    const getIndexChart = (): React.ReactNode => {
        // const { default: ListMarketIndexes } = await import('@/views/components/MarketIndex/ListMarketIndexes');
        return <ListMarketIndexes />; // Trả về component JSX
    };


    // const getIndexChart2 = (): React.ReactNode => {
    //     // alert(isShowIndexChart)
    //     // const { default: ListMarketIndexes } = await import('@/views/components/MarketIndex/ListMarketIndexes');
    //     return <>123</>
    // };


    return (
        < div className='priceboard' >
            {/* {isShowIndexChart}
            {isShowPriBoard} */}
            {/* <div>
                Số lượng mã chứng khoán filter search := {symbolsList?.length}
            </div>

            <div className="instrumentsStatic">
                Số lượng mã chứng khoán theo idPbTab= [{idPbTab}] instrumentsStatic.length:= {instrumentsStatic?.length}
            </div> */}
            {isShowIndexChart && getIndexChart()}
            {/* <div className="instrumentsStatic market-indexes">
            </div> */}

            {/* <div>
                Số lượng mã chứng khoán theo idPbTab= [{idPbTab}] listSymbols.length:= {listSymbols?.length}
            </div>
            <div>
                Số lượng mã chứng khoán theo idPbTab= [{idPbTab}] dataSymbols.length:= {dataSymbols?.length}
            </div> */}
            {isShowPriBoard &&
                <SymbolSelectorTableNew
                    idPbTab={idPbTab}
                    exchangeActive={idPbTab}
                    symbols={dataSymbols}
                    // symbols={dataSymbols.splice(0,5)}
                    listSymbols={listSymbols}
                    className="priceboard-table"
                    onChangeTabs={onChangeTabs}
                />
            }
        </div >
    )
})
export default PriceboardComponents